// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import session from '../../../../share/session';
import util from '../../../../share/util/utils';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';

/** メッセージ内の置き換え文字列定義 */
const DID = '$DID$';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  CONDITION_FAILED: 'conditionFailed',
  CAUTION: 'caution',
  FAILED: 'failed',
  SUCCESS: 'success',
  CANCEL: 'cancel',
  IG_OFF: 'igOff',
  IG_ON: 'igOn',
  NONCONFORMITY: 'nonconformity',
  TIME_OUT_NOT_CHK: 'timeOutNotChk',
  TIME_OUT_CHK: 'timeOutChk',
  RELEASE_PARKING_BRAKE: 'releaseParkingBrake',
  FAULT_DETECTION: 'faultDetection',
  STEERING_CHK: 'steeringChk',
  LIFT_UP_CHK: 'liftUpChk',
  WARN_INTERRUPTION: 'warnInterruption',
  PUSH_BRAKE: 'pushBrake',
  P_RANGE_SELECT: 'pRangeSelect',
  P_RANGE_MAINTAIN: 'pRangeMaintain',
  D_RANGE_SELECT: 'dRangeSelect',
  EXECUTE_MONITOR: 'executeMonitor',
  UNDER_INSPECTION: 'underInspection',
  REAR_DIFF_ERROR: 'rearDiffError',
  STOP_VEHICLE: 'stopVehicle',
  INSPECTION_ERROR: 'inspectionError',
  FINISH_INSPECTION: 'finishInspection',
};

export default {
  name: 'requirement023',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      ratioInfo: '',
      replaceMessage: '',
      systemId: '',
      isInitializationFlg: false,
      isTimer: false,
      isTimeout: false,
      timer: null,
      numWaitTime: 0,
      // ダイアログフラグ
      modal_requirement_023: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
    /* eslint-disable complexity */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.CONDITION_FAILED:
        case PHASE.NONCONFORMITY:
        case PHASE.TIME_OUT_NOT_CHK:
        case PHASE.TIME_OUT_CHK:
        case PHASE.FAULT_DETECTION:
        case PHASE.REAR_DIFF_ERROR:
        case PHASE.INSPECTION_ERROR:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.CAUTION:
        case PHASE.WARN_INTERRUPTION:
          return 'warning';
        case PHASE.START:
        case PHASE.IG_ON:
        case PHASE.IG_OFF:
        case PHASE.RELEASE_PARKING_BRAKE:
        case PHASE.STEERING_CHK:
        case PHASE.LIFT_UP_CHK:
        case PHASE.P_RANGE_SELECT:
        case PHASE.P_RANGE_MAINTAIN:
        case PHASE.D_RANGE_SELECT:
        case PHASE.EXECUTE_MONITOR:
        case PHASE.UNDER_INSPECTION:
        case PHASE.STOP_VEHICLE:
        case PHASE.FINISH_INSPECTION:
        case PHASE.CANCEL:
        default:
          return 'secondary';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_023 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_023 = false;
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** リアデフ点検モード判定 */
    async readRearDiffInspection() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-start'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // 注意表示画面へ遷移
                  this.phase = PHASE.CAUTION;
                  break;
                case 'ng':
                  // ユニット不適合の表示画面へ遷移
                  this.phase = PHASE.NONCONFORMITY;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    async inspectionDisplay() {
      // 中断画面へ遷移
      this.phase = PHASE.CANCEL;
    },

    async engineStartConfirmDisplay() {
      // エンジン始動確認画面へ遷移
      this.phase = PHASE.IG_ON;
    },

    async igOffDisplay() {
      // igOff指示画面へ遷移
      this.phase = PHASE.IG_OFF;
      await this.exit(0);
      this.isInitializationFlg = false;
    },

    /** エンジン始動フラグ */
    async readEngineStartFlg() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_wait_time-egi_start_flg'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // 指定時間を計測
                  this.numWaitTime = response.data.user_data.wait_time;
                  await util.sleep(this.wait_time);
                  // 0に戻す
                  this.numWaitTime = 0;
                  // 指定時間経過後、AT学習用仮故障コード確認フラグ情報の取得を実行
                  await this.readAtTempFailureCodeFlg();
                  break;
                case 'ng':
                  // タイムアウトエラー（中断確認なし）画面へ遷移
                  this.phase = PHASE.TIME_OUT_NOT_CHK;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了：igOff指示画面へ遷移
              this.igOffDisplay();
              break;
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** AT学習用仮故障コード確認フラグ情報の取得 */
    async readAtTempFailureCodeFlg() {
      try {
        this.isLoading = true;
        // 通信を開始 初期化フラグを有効にする
        this.isInitializationFlg = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_with_session_transition'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // パーキングブレーキ解除確認画面に遷移
                  this.phase = PHASE.RELEASE_PARKING_BRAKE;
                  break;
                case 'ng':
                  // 故障検出表示画面に遷移
                  this.phase = PHASE.FAULT_DETECTION;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    async steeringChkDisplay() {
      // ステアリング状態確認画面へ遷移
      this.phase = PHASE.STEERING_CHK;
    },

    async liftUpChkDisplay() {
      // リフトアップ確認画面へ遷移
      this.phase = PHASE.LIFT_UP_CHK;
    },

    async warnInterruptionDisplay() {
      // 点検中断警告表示画面へ遷移
      this.phase = PHASE.WARN_INTERRUPTION;
    },

    /** ブレーキペダル踏み込み指示 */
    async readPushBrakePedal() {
      // ブレーキペダル踏み込み指示画面へ遷移
      this.phase = PHASE.PUSH_BRAKE;
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_wait_time-push_brake_pedal'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // リヤデフ準備中データ書込みを実行
                  await this.writeRearDiffData();
                  break;
                case 'ng':
                  // タイムアウトエラー（中断確認あり）画面に遷移
                  this.phase = PHASE.TIME_OUT_CHK;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** リヤデフ準備中データ書き込み */
    async writeRearDiffData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-rear_diff'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 指定時間を取得
              this.numWaitTime = response.data.user_data.wait_time;
              // 正常終了：Pレンジセレクト指示画面へ遷移
              this.phase = PHASE.P_RANGE_SELECT;
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了：Dレンジセレクト指示画面へ遷移
              this.phase = PHASE.D_RANGE_SELECT;
              // Dレンジセレクト指示の初期処理を実行
              await this.readDRangeSelect();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    async pRangeMaintainDisplay() {
      // Pレンジ維持指示画面に遷移
      this.phase = PHASE.P_RANGE_MAINTAIN;

      this.isLoading = true;
      // リヤデフ準備中データ書込みで取得したwait_timeを基に指定時間を計測
      await util.sleep(this.numWaitTime);
      this.isLoading = false;
      // 0に戻す
      this.numWaitTime = 0;
      // Dレンジセレクト指示画面へ遷移
      this.phase = PHASE.D_RANGE_SELECT;
      // Dレンジセレクト指示の初期処理を実行
      await this.readDRangeSelect();
    },

    /** Dレンジセレクト指示 */
    async readDRangeSelect() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_wait_time-d_range_select'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // SSM用リヤデフ誤組検出データ書込みを実行
                  await this.writeRearDiffMismatchDetectionData();
                  break;
                case 'ng':
                  // タイムアウトエラー（中断確認あり）画面に遷移
                  this.phase = PHASE.TIME_OUT_CHK;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** SSM用リヤデフ誤組検出データ書込み */
    async writeRearDiffMismatchDetectionData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-rear_diff_mismatch'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：ストップランプSW情報の取得画面へ遷移
              this.phase = PHASE.EXECUTE_MONITOR;
              // ストップランプSW情報の取得を実行
              await this.readStopLamp();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** ストップランプSW情報の取得 */
    async readStopLamp() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_wait_time-stop_lamp'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // 前後輪回転比情報の取得を実行
                  await this.readWheelRotationRatioData();
                  break;
                case 'ng':
                  // タイムアウトエラー（中断確認あり）画面に遷移
                  this.phase = PHASE.TIME_OUT_CHK;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 前後輪回転比情報の取得 */
    async readWheelRotationRatioData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-wheel_rotation_ratio'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (response.data.user_data.wheel_rotation_ratio.digits_after_decimal !== null
                && !Number.isInteger(response.data.user_data.wheel_rotation_ratio.value)) {
                //小数点以下編集
                const dec = response.data.user_data.wheel_rotation_ratio.digits_after_decimal;
                this.replaceMessage = response.data.user_data.wheel_rotation_ratio.value.toFixed(dec);
                this.ratioInfo = this.$t(`${this.i18nWsKey}.REQ_WS_23_TXT_14`).replace(DID, this.replaceMessage);
              }
              else {
                //そのまま表示
                this.replaceMessage = response.data.user_data.wheel_rotation_ratio.value;
                this.ratioInfo = this.$t(`${this.i18nWsKey}.REQ_WS_23_TXT_14`).replace(DID, this.replaceMessage);
              }
              // 正常終了：点検中表示画面へ遷移
              if (this.phase !== PHASE.TIME_OUT_CHK) {
                this.phase = PHASE.UNDER_INSPECTION;
              }
              await this.readUnderInspection();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 点検中表示 */
    async readUnderInspection() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-under_inspection'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 指定時間経過するまで処理をループ
              this.numWaitTime = response.data.user_data.wait_time;
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // タイムアウトエラー用タイマーの起動と前後輪回転比情報の取得を再実行
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (!this.isTimer) {
                    this.isTimer = true;
                    this.timer = await setTimeout(() => this.execTimeout(), this.numWaitTime);
                  }
                  if (!this.isTimeout) {
                    // VUE_APP_RETRY_INTERVALの時間分sleep
                    await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
                    // 前後輪回転比情報の取得を実行
                    await this.readWheelRotationRatioData();
                  }
                  break;
                case 'ng':
                  // タイムアウト処理実行確認
                  if (this.timer) {
                    // タイムアウト処理が実行されていた場合、タイマーをリセットする
                    await clearTimeout(this.timer);
                    this.timer = null;
                    this.isTimer = false;
                  }
                  // 点検データの取得を実行
                  await this.readInspectionData();
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // タイムアウト処理実行確認
              if (this.timer) {
                // タイムアウト処理が実行されていた場合、タイマーをリセットする
                await clearTimeout(this.timer);
                this.timer = null;
                this.isTimer = false;
              }
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.numWaitTime = 0;
        this.isLoading = false;
      }
    },

    /** 点検データ取得 */
    async readInspectionData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-inspection_data'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.result) {
                case 'success':
                  // 正常終了の表示を実行
                  await this.readSuccess();
                  break;
                case 'rear_diff_failed':
                  // リヤデフ異常の表示を実行
                  await this.readRearDiffError();
                  break;
                default:
                  // 異常終了の表示画面へ遷移
                  this.phase = PHASE.INSPECTION_ERROR;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 正常終了の表示 */
    async readSuccess() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-success'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：読み出したデータを表示
              if (response.data.user_data.wheel_rotation_ratio.digits_after_decimal !== null
                && !Number.isInteger(response.data.user_data.wheel_rotation_ratio.value)) {
                //小数点以下編集
                const dec = response.data.user_data.wheel_rotation_ratio.digits_after_decimal;
                this.replaceMessage = response.data.user_data.wheel_rotation_ratio.value.toFixed(dec);
                this.ratioInfo = this.$t(`${this.i18nWsKey}.REQ_WS_23_TXT_15`).replace(DID, this.replaceMessage);
              }
              else {
                //そのまま表示
                this.replaceMessage = response.data.user_data.wheel_rotation_ratio.value;
                this.ratioInfo = this.$t(`${this.i18nWsKey}.REQ_WS_23_TXT_15`).replace(DID, this.replaceMessage);
              }
              // 正常終了の表示画面へ遷移
              this.phase = PHASE.SUCCESS;
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** リヤデフ異常処理（要求） */
    async readRearDiffError() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-rear_diff_error'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：読み出したデータを表示
              if (response.data.user_data.wheel_rotation_ratio.digits_after_decimal !== null
                && !Number.isInteger(response.data.user_data.wheel_rotation_ratio.value)) {
                //小数点以下編集
                const dec = response.data.user_data.wheel_rotation_ratio.digits_after_decimal;
                this.replaceMessage = response.data.user_data.wheel_rotation_ratio.value.toFixed(dec);
                this.ratioInfo = this.$t(`${this.i18nWsKey}.REQ_WS_23_TXT_16`).replace(DID, this.replaceMessage);
              }
              else {
                //そのまま表示
                this.replaceMessage = response.data.user_data.wheel_rotation_ratio.value;
                this.ratioInfo = this.$t(`${this.i18nWsKey}.REQ_WS_23_TXT_16`).replace(DID, this.replaceMessage);
              }
              // リヤデフ異常の表示画面へ遷移
              this.phase = PHASE.REAR_DIFF_ERROR;
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 車両停止時指示表示処理 */
    async readStopVehicle() {
      // 車両停止指示画面へ遷移
      this.phase = PHASE.STOP_VEHICLE;
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_wait_time-stop_vehicle'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // 通常停止を実行
                  await this.writeNormalStop();
                  break;
                case 'ng':
                  // タイムアウトエラー（中断確認あり）画面に遷移
                  this.phase = PHASE.TIME_OUT_CHK;
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 通常停止 */
    async writeNormalStop() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write-normal_stop'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：終了表示画面へ遷移
              this.phase = PHASE.FINISH_INSPECTION;
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Exit処理
     * @param {*} numError 0:エラー遷移あり, 1:エラー遷移なし
     * @returns 
     */
    async exit(numError) {
      // NonDefaultSession遷移を行っていない場合、何もしない
      if (!this.isInitializationFlg && numError === 0) {
        return;
      }

      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (numError === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 異常終了：汎用エラー
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** タイムアウト処理 */
    async execTimeout() {
      clearTimeout(this.timer);
      this.timer = null;
      this.isTimer = false;
      this.isTimeout = true;
      this.phase = PHASE.TIME_OUT_CHK;
      return;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    },
  },

  async mounted() {
    this.init();
    // リヤデフ点検モード対応判定
    await this.readRearDiffInspection();
  },
};